module.exports = __webpack_public_path__ + "static/img/clothing_01.3ee34ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/clothing_01.png
// module id = JAbn
// module chunks = 0